import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { genericFormStyling } from '../../../../styles/common/form.styles';

export const MarketDepthQueryStyles = css`
  ${MainStyles}
  ${genericFormStyling}

:host {
    display: contents;
  }

  .segmented-control-min-width {
    min-width: 180px;
  }

  .market-depth-header {
    height: 56px;
    font-size: 18px;
    color: var(--white);
    border-bottom: 1px solid var(--border-1);
    display: flex;
    align-items: center;
    padding: 0 0 0 16px;
  }

  .market-depth-footer {
    display: flex;
    justify-content: end;
    background: var(--modal-footer-bg);
    padding: 25px 16px;
    position: absolute;
    bottom: 0px;
    box-sizing: border-box;
    width: 100%;
    gap: 10px;
  }

  .dialog-content {
    width: 100%;
    padding: 12px;
  }

  .container {
    width: 100%;
  }

  .form-control {
    display: flex;
    flex-direction: column;
  }

  .no-padding-bottom {
    padding-bottom: 0px !important;
  }

  .range-value {
    display: flex;
    gap: 9px;
    width: 250px;
  }

  .minus-sign {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .market-depth-criteria-form {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .center-content {
    justify-content: center;
    padding-right: 16px;
    padding-bottom: 0px;
    padding-top: 18px;
  }

  .multi-select-fix {
    margin-top: -8px;
  }

  .custom-size-select {
    min-width: 150px;
  }

  .custom-segmented-item {
    margin: 0px;
    height: 38px;
  }
`;
